import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrowserTabs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrowserTabs"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor"/><Path d="M5 7.5L11 7.5" stroke="currentColor"/><Path d="M16 7.5L19 7.5" stroke="currentColor"/><Path d="M12 7.5L15 7.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconBrowserTabs;
